<div
  class="scope-row-content flex items-center"
  [class.trading-in-progress]="isTradingInProgress"
  (mouseenter)="onComponentDragEnterDeliverable()"
  (click)="fetchDeliverable($event)">
  <div
    class="column level-{{ level }}"
    [ngClass]="config?.mainColumnClass">
    <div class="flex items-center">
      <mat-icon
        [class.trade-confirmed]="isTraded"
        class="arrow orange material-symbols-rounded"
        [class.active]="scopeElementsService.deliverableStates.selected[deliverable.id]">
        expand_more
      </mat-icon>
      <i
        class="scope-row-icon material-symbols-rounded mr-1"
        [class.trade-confirmed]="isTraded">
        {{ deliverable.fixedPricing ? 'book' : 'description' }}
      </i>
      <div class="flex-col">
        <commentable
          [c-if]="
            config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
          "
          [c-entity]="deliverable"
          c-type="deliverable"
          c-key="name"
          [class.trade-confirmed]="isTraded">
          {{ deliverable.name }}
          <small
            class="text"
            *ngIf="deliverable.tradedFrom">
            (Traded for {{ deliverable.tradedFrom.name }})
          </small>
        </commentable>
        <span
          *ngIf="deliverable.discipline?.name?.length"
          class="source-name">
          {{ deliverable.discipline.name }}
        </span>
      </div>
      <div
        *ngIf="!scopeApprovalFlowService.isStateDraft(config?.scopeVersion.status) && getCommentsCount() > 0"
        class="scope-comments-total-count-icon"
        title="Roll-up Comments Count">
        <div class="scope-comments-count">{{ getCommentsCount() }}</div>
      </div>
    </div>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.DELIVERY_STATUS?.isVisible()">
    <div
      *ngIf="deliveryStatus"
      class="text center scope-status">
      <span
        [class]="deliveryStatus.class"
        [matTooltip]="deliveryStatus.tooltip">
        {{ deliveryStatus.name }}
      </span>
    </div>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.CREATED_BY?.selected">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.createdBy?.getFullname() }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.OWNER?.selected">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.owner?.getFullname() }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.DATE_CREATED?.selected">
    <span [class.trade-confirmed]="isTraded">
      {{ deliverable.createdTs | dateFormat: 'shortDate' }}
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.QUANTITY?.selected">
    <scope-ui-counter
      *ngIf="config?.isEditable"
      [initialValue]="getFieldToDisplay('quantity')"
      [min]="0"
      (onUpdateValue)="updateDeliverable({ quantity: $event })"></scope-ui-counter>
    <span
      *ngIf="!config?.isEditable"
      [class.trade-confirmed]="isTraded">
      <ng-container *ngTemplateOutlet="fieldDifference; context: { fieldName: 'quantity' }"> </ng-container>
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.startDate | dateFormat: 'shortDate' }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.LAST_EDITED?.selected">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.updatedTs | dateFormat: 'shortDate' }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)">
    <span [class.trade-confirmed]="isTraded">{{ deliverable.endDate | dateFormat: 'shortDate' }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.MARK_UP?.selected"
    [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
    [has-privilege-entity]="config?.scopeVersion">
    <span [class.trade-confirmed]="isTraded">
      <ng-container
        *ngTemplateOutlet="
          fieldDifference;
          context: {
            fieldName: 'markup',
            valueFn: formatPercentage,
            defaultValue: deliverable.getMarkup(),
          }
        " />
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.PROFIT?.selected"
    [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
    [has-privilege-entity]="config?.scopeVersion">
    <span [class.trade-confirmed]="isTraded">
      <ng-container
        *ngTemplateOutlet="
          fieldDifference;
          context: {
            fieldName: 'totalProfit',
            valueFn: formatPrice,
            defaultValue: deliverable.getTotalProfit()?.amount,
          }
        " />
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'scopeMarkTotalHours'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      {{ deliverable.scopeMarkTotalHours | formatHours }}
    </commentable>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'scopeMarkTotalSellingPrice'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      {{
        deliverable.scopeMarkTotalSellingPrice
          ? (deliverable.scopeMarkTotalSellingPrice?.amount | convertCurrency: config?.currency)
          : DEFAULT_PLACEHOLDER
      }}
    </commentable>
  </div>
  <div
    class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
    [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_HOURS?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'rateCardTotalHours'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      <ng-container
        *ngTemplateOutlet="
          fieldDifference;
          context: {
            fieldName: 'rateCardTotalHours',
            valueFn: formatHours,
            defaultValue: deliverable.getTotalRateCardHours(),
          }
        " />
    </commentable>
  </div>

  <div
    class="column one--column"
    [hidden]="!config?.userColumns.UNIT_PRICE?.selected">
    <commentable
      class="inline-block"
      [c-entity]="deliverable"
      [c-key]="'agencyUnitPrice'"
      [c-type]="'deliverable'"
      [has-privilege]="Privilege.SCOPE__VIEW_RATES"
      [has-privilege-mask]="'--'">
      <span *ngIf="deliverable.containsUnmappedScopeMarkRoles"> -- </span>
      <span *ngIf="!deliverable.containsUnmappedScopeMarkRoles">
        {{
          deliverable.getUnitSellingPrice()?.amount != null
            ? (deliverable.getUnitSellingPrice().amount | convertCurrency: config?.currency)
            : '--'
        }}
      </span>
    </commentable>
  </div>

  <div
    class="column one--column"
    [hidden]="!config?.userColumns.BUDGET?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'budget'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      {{
        isNil(deliverable.budget)
          ? DEFAULT_PLACEHOLDER
          : (deliverable.budget?.amount | convertCurrency: config?.currency)
      }}
    </commentable>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.BALANCE?.selected">
    <commentable
      [c-if]="
        config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(Privilege.SCOPE_COMMENT__CREATE, currentUser)
      "
      [c-entity]="deliverable"
      [c-key]="'budgetBalance'"
      [c-type]="'deliverable'"
      [class.trade-confirmed]="isTraded">
      <span
        [class.text-error-600]="deliverable.budget && deliverable?.budgetBalance?.amount < 0"
        matTooltip="Over {{ 'deliverable|l' | lang }} budget of {{
          deliverable.budget?.amount | convertCurrency: config?.currency
        }}"
        matTooltipPosition="above"
        matTooltipShowDelay="300"
        [matTooltipDisabled]="!(deliverable.budget && deliverable?.budgetBalance?.amount < 0)">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'budgetBalance',
              valueFn: formatPrice,
              defaultValue: deliverable.budgetBalance?.amount,
            }
          "></ng-container>
      </span>
    </commentable>
  </div>
  <div
    class="column flex flex-nowrap deliverable-nowrap"
    [ngClass]="config?.isTimeline ? 'three--columns' : 'one--column'"
    [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_PRICE?.selected">
    <div
      class="flex flex-col items-center deliverable-agency-price"
      [has-privilege]="Privilege.SCOPE__VIEW_RATES"
      [has-privilege-mask]="DEFAULT_PLACEHOLDER">
      <span
        *ngIf="deliverable?.fixedPricing"
        class="fixed-price-label">
        fixed fee
      </span>

      <ng-container *ngTemplateOutlet="revertFixedCostOffsetIcon"></ng-container>

      <span
        *ngIf="deliverable.containsUnmappedScopeMarkRoles"
        class="inline-block"
        [class.trade-confirmed]="isTraded">
        --
      </span>

      <ng-template #agencyPrice>
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'agencyPrice',
              valueFn: formatPrice,
              defaultValue: deliverable.getTotalSellingPrice()?.amount,
            }
          " />
      </ng-template>

      <ng-container *ngIf="!deliverable.containsUnmappedScopeMarkRoles">
        <div class="flex flex-nowrap items-center justify-center scope-editable-field">
          <commentable
            *ngIf="!isAgencyPriceEditable"
            class="inline-block"
            [class.trade-confirmed]="isTraded"
            [c-entity]="deliverable"
            [c-key]="'agencyTotalPrice'"
            [c-type]="'deliverable'"
            [has-privilege]="Privilege.SCOPE__VIEW_RATES"
            [has-privilege-mask]="DEFAULT_PLACEHOLDER"
            [c-if]="
              config?.scopeVersion.hasPrivilegeValueRestrictionByScopeValue(
                Privilege.SCOPE_COMMENT__CREATE,
                currentUser
              )
            ">
            <ng-container [ngTemplateOutlet]="agencyPrice"></ng-container>
          </commentable>

          <ng-container *ngIf="isAgencyPriceEditable">
            <ng-container *ngIf="!isEditAgencyPrice">
              <ng-container [ngTemplateOutlet]="agencyPrice"></ng-container>

              <mat-icon
                class="material-symbols-rounded fill orange text-sm"
                (click)="editAgencyPrice($event)">
                mode_edit
              </mat-icon>
            </ng-container>

            <scope-ui-input
              *ngIf="isEditAgencyPrice"
              type="text"
              [parseNumber]="true"
              [isCurrency]="true"
              [autofocus]="true"
              [noArrows]="true"
              [maximumLength]="17"
              [currency]="config?.currency"
              [initialValue]="deliverable.getTotalSellingPrice()?.amount"
              [control]="agencyPriceControl"
              (click)="preventDefault($event)"
              (onInputBlurChange)="updateAgencyPrice($event)" />
          </ng-container>
        </div>
      </ng-container>
    </div>

    <ng-template #revertFixedCostOffsetIcon>
      <div
        *ngIf="deliverable.fixedCostOffset && !deliverable.fixedPricing"
        class="overwritten-container"
        (mouseenter)="cancelMenuClose(); menuTrigger.openMenu()"
        (mouseleave)="scheduleMenuClose(menuTrigger)">
        <span
          class="fixed-price-label fixed-price-active"
          [matMenuTriggerFor]="overwrittenMenu"
          #menuTrigger="matMenuTrigger"
          (click)="stickMenu($event)">
          Overwritten
        </span>
        <mat-menu
          #overwrittenMenu="matMenu"
          class="overwritten-tooltip-panel"
          [hasBackdrop]="false"
          [overlapTrigger]="false"
          yPosition="above"
          xPosition="after"
          (closed)="cancelMenuClose(); isMenuSticky = false">
          <div
            class="scope-tooltip--overlay scope-tooltip--overlay--arrow-right"
            (click)="$event.stopPropagation()"
            (mouseenter)="cancelMenuClose()"
            (mouseleave)="scheduleMenuClose(menuTrigger)">
            <span class="inner-tooltip lg">
              <span>
                Value manually overwritten. Actual value is
                <strong class="overwritten-original-price">{{ originalPriceFormatted }}</strong
                >.
                <ng-container *ngIf="isDraftStage">Click 'Revert' to restore the actual value.</ng-container>
              </span>
              <button
                *ngIf="isDraftStage"
                [disabled]="!isAgencyPriceEditable"
                (click)="revertFixedCostOffset($event)">
                Revert
              </button>
              <span
                *ngIf="!isDraftStage"
                class="revert-inactive"
                >Revert</span
              >
            </span>
          </div>
        </mat-menu>
      </div>
    </ng-template>

    <mat-icon
      *ngIf="
        config?.isTimeline &&
        !deliverable.containsUnmappedScopeMarkRoles &&
        deliverable.getTotalSellingPrice()?.amount == 0
      "
      class="scope-error-icon material-symbols-rounded"
      matTooltip="Empty {{ 'deliverable|l' | lang }}. Edit to add components"
      matTooltipShowDelay="300">
      error
    </mat-icon>

    <mat-icon
      *ngIf="config?.isTimeline && deliverable.containsUnmappedScopeMarkRoles"
      class="scope-error-icon material-symbols-rounded"
      matTooltip="This {{ 'deliverable|l' | lang }} has roles which do not exist in your ratecard"
      matTooltipShowDelay="300">
      error
    </mat-icon>
  </div>

  <div
    class="column one--column deliverable-nowrap deliverable-actions"
    [hidden]="!config?.showActionsColumn">
    <button
      *ngIf="showToggleMenu()"
      mat-mini-fab
      class="toggle-button float-right ml-1"
      [ngClass]="config?.isTimeline ? 'mr-1' : 'mr-2'"
      [matMenuTriggerFor]="deliverableMenu"
      (click)="$event.stopPropagation()">
      <mat-icon class="material-symbols-rounded">more_horiz</mat-icon>
    </button>
    <mat-menu
      #deliverableMenu="matMenu"
      backdropClass="customize">
      <ng-container *ngFor="let option of deliverableMenuOptions">
        <button
          *ngIf="!(option.isHidden?.(deliverable) || option.isDetached?.(deliverable))"
          mat-menu-item
          (click)="option.callback(deliverable)">
          <mat-icon class="material-symbols-rounded orange">{{ option.icon() }}</mat-icon>
          <span class="library-option-name">{{ option.name() | langf }}</span>
        </button>
      </ng-container>
    </mat-menu>

    <ng-container *ngFor="let option of deliverableMenuOptions">
      <button
        *ngIf="!option.isHidden?.(deliverable) && option.isDetached?.(deliverable)"
        class="toggle-button float-right ml-1"
        mat-mini-fab
        (click)="option.callback(deliverable)">
        <mat-icon class="material-symbols-rounded fill">mode_edit</mat-icon>
      </button>
    </ng-container>
  </div>
</div>

<div
  *ngIf="!config?.isTimeline"
  class="flex flex-col w-full scope-description-container">
  <description-editor
    class="level-{{ level }} description-editor"
    [(visible)]="scopeElementsService.deliverableStates.description[deliverable.id]"
    [model]="getDeliverableWithDescriptions()"
    [editable]="isEditable"
    [extraDescription]="true"
    [(disableDragging)]="scopeElementsService.disableDragging"
    (onSaveDescription)="updateDeliverable({ description: $event }, false)"
    (onSaveExtraDescription)="updateDeliverable({ description: $event.main, extraDescription: $event.extra }, false)"
    (onSaveNote)="updateDeliverable({ internalNote: $event }, false)">
  </description-editor>

  <!-- Accept/Reject Deliverables -->
  <ng-container *ngIf="scopeApprovalFlowService.stateChecks">
    <div
      class="deliverable-review-container"
      *ngIf="
        scopeApprovalFlowService.stateChecks.deliverableStatus.deliverablesInReview &&
        scopeApprovalFlowService.stateChecks.isCurrentVersion &&
        scopeApprovalFlowService.stateChecks.inReviewState.currentMember
      ">
      <div class="deliverable-review-collaborators">
        <div class="approval-collaborators-list flex flex-col gap-1">
          <div class="flex items-center gap-0.5">
            <mat-icon class="material-symbols-rounded">people</mat-icon>
            <h6 class="product-heading-bold">Collaborators</h6>
          </div>
          <div class="flex gap-2">
            <div
              class="approval-collaborators-list-item"
              *ngFor="let collaborator of config?.scopeVersion.collaborators | orderBy: 'id'; trackBy: trackById">
              <ng-container *ngIf="{ showAlt: false } as memberScope">
                <div
                  *ngIf="memberScope.showAlt"
                  class="user-avatar-placeholder">
                  <p>{{ collaborator.user.firstName.charAt(0) }}</p>
                </div>
                <img
                  *ngIf="!memberScope.showAlt"
                  class="user-avatar-placeholder"
                  src="{{ cdnConfig!.userProfileUrl + '/' + collaborator.user.photoUri }}"
                  alt=""
                  (error)="memberScope.showAlt = true" />
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="scopeApprovalFlowService.stateChecks.deliverableStatus.deliverablesInReview"
        class="deliverable-review-collaborators">
        <div class="approval-collaborators-list flex flex-col gap-1">
          <div class="flex items-center gap-0.5">
            <mat-icon class="material-symbols-rounded">eyeglasses</mat-icon>
            <h6 class="product-heading-bold">Reviewers</h6>
          </div>
          <div class="flex gap-2">
            <div
              class="approval-collaborators-list-item"
              *ngFor="let reviewer of deliverable.reviewers | orderBy: 'id'; trackBy: trackById">
              <ng-container *ngIf="{ showAlt: false } as memberScope">
                <i
                  *ngIf="reviewer.vote === 'ACCEPT'"
                  class="material-symbols-rounded accepted">
                  done
                </i>
                <i
                  *ngIf="reviewer.vote === 'DECLINE'"
                  class="material-symbols-rounded rejected">
                  close
                </i>
                <div
                  *ngIf="memberScope.showAlt"
                  class="user-avatar-placeholder">
                  <p>{{ reviewer.voter.firstName.charAt(0) }}</p>
                </div>
                <img
                  *ngIf="!memberScope.showAlt"
                  class="user-avatar-placeholder"
                  src="{{ cdnConfig!.userProfileUrl + '/' + reviewer.voter.photoUri }}"
                  alt=""
                  (error)="memberScope.showAlt = true" />
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="
          scopeApprovalFlowService.stateChecks.deliverableStatus.deliverablesInReview &&
          config?.scopeVersion.status === 'SUBMITTED'
        "
        class="deliverable-review-actions">
        <ng-container
          *ngIf="
            this.scopeApprovalFlowService.findDeliverableReviewer(currentUser.id, deliverable) as deliverableReviewer
          ">
          <button
            [class.deliverable-accepted]="deliverableReviewer?.vote === 'ACCEPT'"
            [disabled]="deliverableReviewer?.vote === 'ACCEPT'"
            (click)="onAcceptDeliverable.emit(deliverable)">
            {{ deliverableReviewer?.vote === 'ACCEPT' ? 'Accepted' : 'Accept' }}
          </button>
          <button
            [class.deliverable-rejected]="deliverableReviewer?.vote === 'DECLINE'"
            [disabled]="deliverableReviewer?.vote === 'DECLINE'"
            (click)="onRejectDeliverable.emit(deliverable)">
            {{ deliverableReviewer?.vote === 'DECLINE' ? 'Rejected' : 'Reject' }}
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<div
  id="component-drop-{{ deliverable.id }}"
  cdkDropList
  [cdkDropListData]="deliverable.components"
  [cdkDropListConnectedTo]="config?.deliverableDrops"
  [cdkDropListDisabled]="!isEditable || !!scopeElementsService.deliverableStates.selected[deliverable.id]"
  (cdkDropListDropped)="dropComponentToDeliverable($event)"
  [hidden]="!!scopeElementsService.deliverableStates.selected[deliverable.id]"
  style="min-height: 8px"></div>

<ng-container *ngIf="scopeElementsService.deliverableStates.selected[deliverable.id]">
  <div
    *ngIf="isEmptyDeliverable()"
    class="text-for-empty deliverable-empty">
    <p class="undertext">This {{ 'deliverable' | lang }} is empty</p>
  </div>

  <scope-components
    [level]="level + 1"
    [config]="updatedConfig"
    [deliverable]="deliverable"
    [components]="componentsMap['undefined']"
    [componentMenuOptions]="componentMenuOptions"
    [feeMenuOptions]="feeMenuOptions"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onUpdateComponentFee)="onUpdateFeeItem.emit($event)"
    (onOverrideQuantity)="onOverrideComponentQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)">
  </scope-components>

  <scope-deliverable-sections
    [sections]="deliverable.sections"
    [componentsMap]="componentsMap"
    [config]="updatedConfig"
    [deliverable]="deliverable"
    [feeMenuOptions]="feeMenuOptions"
    [componentMenuOptions]="componentMenuOptions"
    [level]="level + 1"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onUpdateDeliverableSectionTpc)="onUpdateDeliverableSectionTpc.emit($event)"
    (onReorderDeliverableSectionTpcs)="onReorderDeliverableSectionTpcs.emit($event)"
    (onUpdateFeeItem)="onUpdateFeeItem.emit($event)"
    (onOverrideComponentQuantity)="onOverrideComponentQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)">
  </scope-deliverable-sections>

  <div
    *ngIf="config?.userColumns.SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS?.selected && !config?.isTimeline"
    class="scope-row-header flex items-center align-middle"
    [has-setting]="ApplicationSetting.SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS"
    [hidden]="
      !(deliverable.componentsInitialised && (deliverable.sections?.length || componentsMap['undefined']?.length))
    ">
    <div class="column level-{{ level + 1 }} {{ config?.componentMainColumnClass }}">
      <span isEllipsisActive>{{ 'deliverable|u' | lang }} ACTUALS</span>
    </div>
    <div class="column four--columns">
      <span isEllipsisActive>Complete percentage: {{ deliverable.traffickedPercentageComplete || 0 }}%</span>
    </div>
    <div
      class="column two--columns"
      [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected"></div>
    <div
      class="column two--columns"
      [hidden]="!config?.userColumns.AGENCY_PRICE?.selected">
      <span class="flex items-center">Actuals: {{ deliverable.getActualHours() }} hrs</span>
    </div>
    <div class="column two--columns"></div>
  </div>

  <scope-third-party-costs
    *ngIf="deliverable.thirdPartyCosts?.length && !config?.isTimeline"
    [parent]="deliverable"
    [config]="updatedConfig"
    [level]="level + 1"
    [columns]="getTpcColumns()"
    (onUpdateTpc)="updateDeliverableTpc($event)"
    (onReorderTpcs)="reorderDeliverableTpcs($event)">
  </scope-third-party-costs>

  <scope-fees
    *ngIf="deliverable.feeItems?.length && !config?.isTimeline"
    [has-setting]="ApplicationSetting.DELIVERABLE__ENABLE_FEES"
    [parent]="deliverable"
    [columns]="scopeElementsService.deliverableFeeColumns"
    [level]="level + 1"
    [config]="updatedConfig"
    [feeMenuOptions]="feeMenuOptions"
    [tableStates]="scopeElementsService.deliverableFeeStates"
    (onUpdateFeeItem)="onUpdateFeeItem.emit({ feeItem: $event, deliverable })">
  </scope-fees>
</ng-container>

<ng-template
  #fieldDifference
  let-fieldName="fieldName"
  let-valueFn="valueFn"
  let-defaultValue="defaultValue">
  <scope-field-difference
    [isChangeRequest]="config?.isChangeRequest"
    [fieldName]="fieldName"
    [defaultValue]="defaultValue"
    [changes]="deliverable.changes"
    [getFieldToDisplay]="getFieldToDisplay"
    [showDiff]="showDiff"
    [valueFn]="valueFn"
    [showNetDelta]="showNetChanges(fieldName)"
    [netDeltaValue]="getNetChanges(fieldName, defaultValue)" />
</ng-template>
